export enum ActionType {
  SET_LOCATION = "SET_LOCATION",
  SET_FACILITY = "SET_FACILITY",
  SET_DRIVER = "SET_DRIVER",
  SET_VISIT = "SET_VISIT",
  SET_VISIT_SUMMARY = "SET_VISIT_SUMMARY",
  SET_ASSET_INFO = "SET_ASSET_INFO",
  SET_APPOINTMENT = "SET_APPOINTMENT",
  SET_FILES = "SET_FILES",
  SET_PATH = "SET_PATH",
  SET_EDOCS = "SET_EDOCS",
  SET_FACILITY_CODE = "SET_FACILITY_CODE",
  SET_RESENDSMS = "SET_RESENDSMS",
  SET_DIRECTION = "SET_DIRECTION",
  SET_VISIT_PURPOSE = "SET_VISIT_PURPOSE",
  SET_CARRIER_SEARCH = "SET_CARRIER_SEARCH",
  ENABLE_APP_BAR = "ENABLE_APP_BAR",
  SET_LOAD_STATUS = "SET_LOAD_STATUS"
}

export const RESET_STORE = "RESET_STORE"

interface actionLocation {
  type: ActionType.SET_LOCATION
  payload: string
}
interface actionResendsms {
  type: ActionType.SET_RESENDSMS
  payload: string
}

interface actionPath {
  type: ActionType.SET_PATH
  payload: string
}

interface actionFacilityCode {
  type: ActionType.SET_FACILITY_CODE
  payload: string
}

interface actionFacility {
  type: ActionType.SET_FACILITY
  payload: facility
}

interface actionDriver {
  type: ActionType.SET_DRIVER
  payload: driver
}

interface actionVisit {
  type: ActionType.SET_VISIT
  payload: visit
}

interface actionVisitPurpose {
  type: ActionType.SET_VISIT_PURPOSE
  payload: visitPurposeState
}

interface actionVisitSummary {
  type: ActionType.SET_VISIT_SUMMARY
  payload: visitSummaryState
}
interface actionAssetInfo {
  type: ActionType.SET_ASSET_INFO
  payload: assetInfo
}
interface actionAppointment {
  type: ActionType.SET_APPOINTMENT
  payload: appointment
}

interface actionFile {
  type: ActionType.SET_FILES
  payload: Array<Object>
}

interface actionDirection {
  type: ActionType.SET_DIRECTION
  payload: any
}

interface actionEdocs {
  type: ActionType.SET_EDOCS
  payload: Array<Object>
}

interface actionCarrierSearch {
  type: ActionType.SET_CARRIER_SEARCH
  payload: carrierSearch
}

interface actionEnableAppBar {
  type: ActionType.ENABLE_APP_BAR
  payload: boolean
}

interface actionLoadDetails {
  type: ActionType.SET_LOAD_STATUS
  payload: loadState
}

export type Action =
  | actionLocation
  | actionFacility
  | actionDriver
  | actionVisit
  | actionFile
  | actionEdocs
  | actionAppointment
  | actionPath
  | actionFacilityCode
  | actionResendsms
  | actionDirection
  | actionVisitSummary
  | actionAssetInfo
  | actionVisitPurpose
  | actionCarrierSearch
  | actionEnableAppBar
  | actionLoadDetails

export interface locationState {
  location: string
  path: string
  facilityCode: string
  enableAppBar: boolean
}

export interface fileState {
  files: file[]
}
export interface edocsState {
  edocs: edocs[]
  isResendVisible: boolean
}

export interface directionState {
  direction: {}
}
export interface facilityState {
  facility: facility
}

export interface facility {
  id: string
  name: string
  isGateLink: boolean
}

export interface driverState {
  driver: driver
}

export interface driver {
  name: string
  phone: string
}

export interface visitState {
  visit: visit
}
export interface visitPurposeState {
  visitPurpose: string
}
export interface visitSummaryState {
  visitsummary: any
}
export interface assetInfo {
  asset: asset
}

export interface visit {
  id: string
  visit: any
  visitPurpose: string
}

export interface visitPurpose {
  purpose: string
}

export interface appointmentState {
  appointment: appointment
}

export interface appointment {
  type: string
  details: appointmentDetails[]
  matchingVisitDetails: matchingVisitDetail
  smsMatchingVisitDetails: matchingVisitDetail
  isNewSession: boolean
}

export interface asset {
  id: String
  tractor: string
  trailer: string
  usdot: string
  companyName: string
  referenceNumber: string
  estimatedCheckout: string
  HOS: string
  RFIDCode: string
  equipmentType: string
  trailerStatus: string
  permalink: string
}

export interface matchingVisitDetail {
  id: string
  status: string
}
export interface file {
  loadNumber: string
  files: Array<Object>
}
export interface edocs {
  edocs: Array<Object>
}

export interface direction {
  direction: {}
}

export interface appointmentDetails {
  direction: string
  referenceNumber: string
  scheduledTime: string
  equipment: equipment
}

export interface equipment {
  id: string
  type: string
  carrier: carrier
}

export interface carrier {
  name: string
  scac: string
}

export interface carrierSearch {
  carrierDetails: carrierFromSearch[]
}

export interface carrierFromSearch {
  id: string
  name: string
  permalink: string
  logo: string
  type: string
  status: carrierStatus
  contact: carrierContact
  address: carrierAddress
  identifiers: carrierIdentity[]
  identifications: carrierIdentity[]
}

export interface carrierStatus {
  data: string
  network: string
}

export interface carrierContact {
  name: string
  phone: string
  email: string
}

export interface carrierAddress {
  city: string
  state: string
  stateCode: string
  country: string
  countryCode: string
}

export interface carrierIdentity {
  type: string
  value: string
}

export interface loadState {
  loadDetails: loadDetails
}

export interface loadDetails {
  code: string
  name: string
  permalink: string
}
